import { Material } from '@babylonjs/core';

interface Fansea3DStageInspectorStateProps {
  defaultMaterial: Material[];
  backgroundName: String;
  isAutoRotating?: boolean;
  lightSetup?: string;
  lightScale?: number;
  lightIntensityScale?: number;
  showLights?: boolean;
}

const Fansea3DStageInspectorState: Fansea3DStageInspectorStateProps = {
  defaultMaterial: [],
  backgroundName: 'Dark',
};

export default Fansea3DStageInspectorState;
